export default __webpack_public_path__ + "static/media/아로마_web.b8af1cce.jpg";